<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">Last news content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">

        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.title" />
        </div>
        <div class="field-sec">
          <label>More news:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.more_news" />
        </div>
        <div class="field-sec">
          <label>News page link:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.news_link" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is for testing the content but may not be functional:
      <br>
      <div class="last-news-sec" id="last_news_sec">
        <h2 id="last_news_title">{{ fit20.blockToEdit.title }}</h2>
        <div id="last_news_div">
          <a class='last-news-item0' href="#">
            <div class="last-news-img-div not-fixed">
              <img src="https://www.fit20.com//files/images/NL/NL%20News/hetfit20medicijn.jpg" alt="last news image" />
            </div>
            <div class="titles-text-sec not-fixed">
              <div class="titles-text not-fixed">
                <div class="green-title">main title 1</div>
                <div class="gray-title">sub title 1</div>
              </div>
            </div>
          </a>
          <a class='last-news-item0' href="#">
            <div class="last-news-img-div not-fixed">
              <img src="https://www.fit20.com//files/images/NL/NL%20News/hetfit20medicijn.jpg" alt="last news image" />
            </div>
            <div class="titles-text-sec not-fixed">
              <div class="titles-text not-fixed">
                <div class="green-title">main title 2</div>
                <div class="gray-title">sub title 2</div>
              </div>
            </div>
          </a>
          <a class='last-news-item0' href="#">
            <div class="last-news-img-div not-fixed">
              <img src="https://www.fit20.com//files/images/NL/NL%20News/hetfit20medicijn.jpg" alt="last news image" />
            </div>
            <div class="titles-text-sec not-fixed">
              <div class="titles-text not-fixed">
                <div class="green-title">main title 3</div>
                <div class="gray-title">sub title 3</div>
              </div>
            </div>
          </a>
        </div>
        <div id="more_news_btn"><a href="#">{{ fit20.blockToEdit.more_news }}</a></div>
      </div>
      <br>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  name: 'LastNews',
  props: ["fit20", "saveBlock", "cancelEditing"],
};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/* example style */
.last-news-sec {
  text-align: center !important;
  padding: 80px 0 50px 0 !important;
}

.last-news-sec-news-page {
  background-color: #009fe31f !important;
}

.last-news-hidden {
  display: none;
}

#last_news_title {
  padding-bottom: 55px !important;
}

#last_news_div {
  display: flex !important;
  justify-content: space-between !important;
  padding: 0 30px 20px 30px !important;
  max-width: 1500px !important;
  margin: 0 auto;
}

#last_news_div a {
  width: calc(95% / 3) !important;
  box-shadow: 0 10px 10px rgba(46, 46, 46, 0.356) !important;
  border-radius: 10px !important;
  font-family: 'VAG Rounded Std light light', Verdana, Tahoma, sans-serif !important;
  max-height: 400px !important;
  max-width: 420px;
}

#last_news_div a:hover {
  box-shadow: 0 0 20px rgba(46, 46, 46, 0.356) !important;
}

.last-news-img-div {
  width: 100% !important;
  height: 70% !important;
  overflow: hidden !important;
}

#last_news_div a img {
  max-width: 100% !important;
  /* max-height: 350px; */
  border-top-right-radius: 10px !important;
  border-top-left-radius: 10px !important;
  overflow: hidden !important;
}

.titles-text-sec {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 30% !important;
  background-color: white !important;
  border-radius: 10px !important;
}

#last_news_div .titles-text {
  display: inline-block !important;
  padding: 15px !important;
  margin: auto !important;
}

.green-title {
  color: #92d400 !important;
  font-weight: bold !important;
}

body div.gray-title {
  color: #616365 !important;
}

#more_news_btn {
  margin-top: 25px !important;
}

#more_news_btn a {
  font-family: 'VAG Rounded Std light light', Verdana, Tahoma, sans-serif !important;
  text-align: center !important;
  /* margin-right: 100px !important; */
  padding: 10px 30px !important;
  color: #009df4 !important;
  background-color: white !important;
  font-size: 18px !important;
  border: solid 1px #009df4 !important;
  border-radius: 25px !important;
  transition: color 0.5s, background-color 0.5s !important;
}

#more_news_btn a:link,
#more_news_btn a:active,
#more_news_btn a:visited {
  color: #009df4 !important;
  background-color: white !important;
  text-decoration: none !important;
}

#more_news_btn a:hover {
  color: white !important;
  background-color: #009fe3 !important;
  text-decoration: none !important;
}

@media only screen and (max-width: 1030px) {
  .last-news-img-div {
    height: 60% !important;
  }

  .titles-text-sec {
    height: 40% !important;
  }

  /* #last_news_div a img {
      max-height: 300px;
    } */
}

@media only screen and (max-width: 855px) {
  .last-news-img-div {
    height: 60% !important;
  }

  #last_news_sec #last_news_div .titles-text {
    padding: 10px !important;
    font-size: 14px !important;
  }

  #last_news_sec #last_news_div {
    line-height: normal !important;
  }

  #more_news_btn {
    line-height: normal !important;
  }

  #last_news_sec #last_news_title div.green-title,
  #last_news_sec #last_news_div div.gray-title {
    line-height: normal !important;
  }
}

@media only screen and (max-width: 750px) {
  #last_news_div a.last-news-item0 {
    width: 95% !important;
    max-height: 300px !important;
    max-width: 350px !important;
  }

  #last_news_div {
    justify-content: center !important;
  }

  .last-news-item1,
  .last-news-item2 {
    display: none;
  }

  .last-news-img-div {
    height: 70% !important;
  }

  #last_news_div .titles-text {
    padding: 5px !important;
    font-size: 12px !important;
  }

  .titles-text-sec {
    height: 30% !important;
  }

  .last-news-sec {
    padding: 20px 0 12px 0 !important;
  }

  #more_news_btn a {
    padding: 7px 20px !important;
    font-size: 15px !important;
  }

  #last_news_title {
    padding-bottom: 25px !important;
  }

  #more_news_btn {
    margin-top: 20px !important;
    margin-bottom: 10px !important;
  }
}
</style>
